import TaskNotificationTitleAssigned from "./TaskNotificationTitleAssigned";
import TaskNotificationTitleCreatorAssigned from "./TaskNotificationTitleCreatorAssigned";
import TaskNotificationTitleCreatorSeriesClosed from "./TaskNotificationTitleCreatorSeriesClosed";
import TaskNotificationTitleCreatorSeriesEnd from "./TaskNotificationTitleCreatorSeriesEnd";
import TaskNotificationTitleCreatorSeriesUpdate from "./TaskNotificationTitleCreatorSeriesUpdate";
import TaskNotificationTitleCreatorStatus from "./TaskNotificationTitleCreatorStatus";
import TaskNotificationTitleCreatorUserPickup from "./TaskNotificationTitleCreatorUserPickup";
import { ComponentNotificationTitle } from "../types/task-notification.types";

interface TaskNotificationTitleProps {
  component: ComponentNotificationTitle;
  read: boolean;
}
const TaskNotificationTitle = ({
  component,
  read,
}: TaskNotificationTitleProps) => {
  const { type } = component;
  switch (type) {
    case "notification-title-assigned":
      return <TaskNotificationTitleAssigned {...component} read={read} />;
    case "notification-title-creator-user-pickup":
      return (
        <TaskNotificationTitleCreatorUserPickup {...component} read={read} />
      );
    case "notification-title-creator-status":
      return <TaskNotificationTitleCreatorStatus {...component} read={read} />;
    case "notification-title-creator-assigned":
      return (
        <TaskNotificationTitleCreatorAssigned {...component} read={read} />
      );
    case "notification-title-series-close":
      return (
        <TaskNotificationTitleCreatorSeriesClosed {...component} read={read} />
      );
    case "notification-title-series-end":
      return (
        <TaskNotificationTitleCreatorSeriesEnd {...component} read={read} />
      );
    case "notification-title-series-update":
      return (
        <TaskNotificationTitleCreatorSeriesUpdate {...component} read={read} />
      );
  }
};

export default TaskNotificationTitle;
